/* ig-review-line.js  v4  2026-08-27
   Google review rating directly under the product title. ALL WIDTHS.

   Larry, 27 Aug: "can you add our google review on top under the product name
   so people know our review?" - then "the website should mirror the changes".

   POSITION: under the TITLE, above the price, on mobile and desktop alike.
   Larry was asked directly and chose this over sitting under the price.
   On mobile the anchor is the title inside .ig-pdp-lead (the block that moves
   above the photo); on desktop that block does not exist and the same title
   inside .product__detail is used instead. One insert rule, two layouts.

   ============================================================
   THE ONLY THING TO EDIT IS THIS BLOCK
   ============================================================
   Numbers come from the Infinite Gems Google Business Profile, supplied by
   Larry on 27 Aug: 5.0 stars, 30 Google reviews. Listing is "Infinite Gems |
   Fine Bespoke Jewelry Atelier | Natural Sapphire Ruby Emerald | Diamonds -
   Jewelry store in Hong Kong".

   These are a public claim to customers, so KEEP THEM CURRENT - bump COUNT
   whenever the Google listing moves. Nothing else needs touching: the star
   fill is derived from rating / 5, so a future 4.9 draws a 98% fill by itself.
   ============================================================ */
(function () {
  'use strict';

  var CFG = {
    rating: 5.0,
    count:  30,
    url:    'https://share.google/6gqh8P55dnfq5Ufs9',
    label:  'Google reviews'
  };

  var built = false;

  function ready() {
    return typeof CFG.rating === 'number' && CFG.rating > 0 &&
           typeof CFG.count === 'number' && CFG.count > 0;
  }

  function style() {
    var s = document.createElement('style');
    s.textContent =
      '.ig-grl{display:flex;align-items:center;gap:6px;margin:5px 0 6px;text-decoration:none;color:inherit;font-size:12px;line-height:1}' +
      '.ig-grl__s{position:relative;display:inline-block;font-size:13px;letter-spacing:1px;color:#D8D9DE;white-space:nowrap}' +
      '.ig-grl__f{position:absolute;top:0;left:0;overflow:hidden;color:#E8A32D;white-space:nowrap}' +
      '.ig-grl__n{font-weight:600;color:#192B54}' +
      '.ig-grl__c{color:#6B6F7A;text-decoration:underline;text-underline-offset:2px}' +
      '.ig-grl__c:hover{color:#192B54}' +
      /* no room for it once the mobile lead block collapses to one line */
      '.ig-pdp-lead.is-stuck .ig-grl{display:none}';
    (document.head || document.documentElement).appendChild(s);
  }

  function build() {
    if (built) return;
    if (!ready()) return;

    var title = document.querySelector('.ig-pdp-lead .product__title') ||
                document.querySelector('.product__detail .product__title') ||
                document.querySelector('.product__title');
    if (!title || !title.parentNode) return;
    if (document.querySelector('.ig-grl')) { built = true; return; }

    built = true;
    style();

    var pct = Math.max(0, Math.min(100, (CFG.rating / 5) * 100));

    var el = document.createElement(CFG.url ? 'a' : 'div');
    el.className = 'ig-grl';
    if (CFG.url) {
      el.href = CFG.url;
      el.target = '_blank';
      el.rel = 'noopener';
    }
    el.setAttribute('aria-label', CFG.rating + ' out of 5, ' + CFG.count + ' ' + CFG.label);

    var stars = document.createElement('span');
    stars.className = 'ig-grl__s';
    stars.setAttribute('aria-hidden', 'true');
    stars.textContent = '★★★★★';

    var fill = document.createElement('span');
    fill.className = 'ig-grl__f';
    fill.style.width = pct + '%';
    fill.textContent = '★★★★★';
    stars.appendChild(fill);

    var num = document.createElement('span');
    num.className = 'ig-grl__n';
    num.textContent = CFG.rating.toFixed(1);

    var cnt = document.createElement('span');
    cnt.className = 'ig-grl__c';
    cnt.textContent = CFG.count + ' ' + CFG.label;

    el.appendChild(stars);
    el.appendChild(num);
    el.appendChild(cnt);

    title.parentNode.insertBefore(el, title.nextSibling);
  }

  function run() {
    build();
    if (built || !ready()) return;
    /* on mobile the lead block is created by ig-pdp-info-first.js, which may
       not have run yet - watch for the title to appear in its new home */
    if (window.MutationObserver) {
      var o = new MutationObserver(function () { build(); if (built) o.disconnect(); });
      o.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
}());
